export const caretakersLocationOffset = 0
export const caretakersLocationLimit = 150

export interface CaretakerLocation {
  caretakerId: string
  name: string
  latitude: number
  longitude: number
  hasActiveProSubscription: boolean
  isVerified: boolean
}

export interface CaretakerLocationDto {
  caretakerId: string
  name: string
  latitude: number
  longitude: number
  hasActiveProSubscription: boolean
  isVerified: boolean
}

export enum CaretakerLocationFilters {
  extra = 'forExtra',
  kids = 'forChild',
  senior = 'forAdult',
}



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/caretakersLocation/caretakersLocation.model.ts